module.exports = __webpack_public_path__ + "img/antes_despues_50.0cc1ec8a.png";